import { useEffect } from "react";
import { isEditableTarget } from "../lib/isEditableTarget";

const SEQUENCE = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
] as const;

export function useKonamiCode(onTrigger: () => void) {
  useEffect(() => {
    let index = 0;
    function handleKeyDown(e: KeyboardEvent) {
      if (isEditableTarget(e)) return;
      const expected = SEQUENCE[index];
      if (!expected) return;
      const key = expected.length === 1 ? e.key.toLowerCase() : e.key;
      if (key === expected) {
        index += 1;
        if (index === SEQUENCE.length) {
          index = 0;
          onTrigger();
        }
      } else {
        index = key === SEQUENCE[0] ? 1 : 0;
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onTrigger]);
}
